import * as THREE from "three";
import {
  areColliding,
  teeth3DControlsObjectByJaw,
  teeth3DControlsObjectByName,
} from "./teethControls/TeethPositionHelper";
import { idleManager } from "./Scene";
import { heatMapManager } from "./Mesh";

export class TeethHeatmapGenerator {
  //#region public variables
  currentQueueLength = 0;
  timeOut = [];
  active3DControls = false;
  heatMapGenerationBlob = new Blob(
    [
      `onmessage = function (e) {
    const { vertices1, vertices2, isLower } = e.data;
    const colors = new Float32Array(vertices1.length);
    let assigned;

        let dx;
        let dy;
        let distance ;
        let counterOut = 0, counterRed = 0, counterOrange = 0,counterGreen = 0;
        let maxDistance;
        let yDistance;
    for (let index1 = 0; index1 < vertices1.length; index1 += 3) {
      maxDistance = -Infinity;
      assigned = false
      for (let index2 = 0; index2 < vertices2.length; index2 += 3) {

         dx = vertices1[index1] - vertices2[index2];
         dy = vertices1[index1 + 2] - vertices2[index2 + 2];
         distance = dx * dx + dy * dy;
        
        if (distance > 0.1225) {
          continue;
        }
        yDistance = isLower * (vertices2[index2 + 1] - vertices1[index1 + 1]);
        if (yDistance > maxDistance) {
          maxDistance = yDistance;
        if (maxDistance > 0.49) {
          colors[index1] = 0.85;
          colors[index1 + 1] = 0;
          colors[index1 + 2] = 0.002;
          assigned = true;
          break;
        }
          }

        
    }
      if (!assigned)
      {
        if (maxDistance > 0.2) {

          colors[index1] = 1.0;
          colors[index1 + 1] = 0.647;
          colors[index1 + 2] = 0.0;
        }
        else if (maxDistance > 0.1) {

          colors[index1] = 0.0;
          colors[index1 + 1] = 1.0;
          colors[index1 + 2] = 0.0;
        }
        else
        {
          colors[index1] = 1.0;
          colors[index1 + 1] = 1.0;
          colors[index1 + 2] = 1.0;
         }
      }
    }
    self.postMessage(colors, [colors.buffer]);
  }`,
    ],
    { type: "application/javascript" },
  );
  task = [];
  // #endregion
  constructor() {
    setInterval(this.executePendingTask.bind(this), 100);
  }
  addTask(upperTeeth, lowerTeeth) {
    this.task.push([upperTeeth, lowerTeeth]);
  }
  executePendingTask() {
    if (
      !this.task ||
      this.task.length === 0 ||
      this.currentQueueLength !== 0 ||
      !idleManager.getIdleState() ||
      this.active3DControls
    ) {
      return;
    }

    const currentTaskGroup = this.task.shift();

    for (let index1 = 0; index1 < currentTaskGroup[0].length; index1++) {
      const firstTooth = currentTaskGroup[0][index1];
      for (let index2 = 0; index2 < currentTaskGroup[1].length; index2++) {
        if (index1 + index2 <= 10 || index1 + index2 >= 21) {
          // remove far teeth by teeth index
          continue;
        }
        const secondTooth = currentTaskGroup[1][index2];
        if (this.verifyTask(firstTooth, secondTooth)) {
          this.generateHeatmap(false, firstTooth, secondTooth); // run the task for upper
        }

        if (this.verifyTask(secondTooth, firstTooth)) {
          this.generateHeatmap(true, secondTooth, firstTooth); // run the task for lower
        }
      }
    }
  }

  /**
   *
   * @param {Mesh[]} upper
   * @param {Mesh[]} lower
   * @returns
   */
  executeTaskImmediately(upper, lower) {
    if (!upper || !lower) {
      return;
    }

    const currentTaskGroup = [upper, lower];

    this.resetColorsArray(upper);
    this.resetColorsArray(lower);

    for (let index1 = 0; index1 < currentTaskGroup[0].length; index1++) {
      const firstTooth = currentTaskGroup[0][index1];
      for (let index2 = 0; index2 < currentTaskGroup[1].length; index2++) {
        const secondTooth = currentTaskGroup[1][index2];
        if (this.verifyImmediateTask(firstTooth, secondTooth)) {
          this.generateHeatmap(false, firstTooth, secondTooth); // run the task for upper
        }

        if (this.verifyImmediateTask(secondTooth, firstTooth)) {
          this.generateHeatmap(true, secondTooth, firstTooth); // run the task for lower
        }
      }
    }

    /* for (let index2 = 0; index2 < currentTaskGroup[1].length; index2++) {
      const secondTooth = currentTaskGroup[1][index2];
      if (!secondTooth.hasCollision) {
        this.resetColorsArray([secondTooth]);
      }
    } */
  }

  /**
   *
   * @param {Mesh[]} upper
   * @param {Mesh[]} lower
   * @returns
   */
  executeTaskImmediatelyAfterTime(upper, lower, time = 150) {
    this.timeOut.push(
      setTimeout(this.executeTaskImmediately.bind(this), time, upper, lower),
    );
  }

  clearTimeout() {
    for (let taskIndex = this.timeOut.length; taskIndex > 0; taskIndex--) {
      clearTimeout(this.timeOut.pop());
    }
  }
  verifyTask(firstMesh, secondMesh) {
    if (firstMesh.isOcclusalCalculated) {
      return false;
    }
    if (!areColliding(firstMesh, secondMesh)) {
      return false;
    }
    return true;
  }

  verifyImmediateTask(firstMesh, secondMesh) {
    if (!areColliding(firstMesh, secondMesh)) {
      return false;
    }
    return true;
  }

  resetColorsArray(objects) {
    for (let objectIndex = 0; objectIndex < objects.length; objectIndex++) {
      const colors = objects[objectIndex].geometry.attributes.color.array;

      for (let colorIndex = 0; colorIndex < colors.length; colorIndex++) {
        colors[colorIndex] = 1.0;
      }
      objects[objectIndex].geometry.attributes.color.needsUpdate = true;
    }
  }

  resetHeatmapCollisionState(objects) {
    objects.forEach(object => {
      object.hasCollision = false;
    });
  }

  generateHeatmap(isLower, firstTooth, secondTooth) {
    this.currentQueueLength++;
    this.cpuCalc(isLower, firstTooth, secondTooth);
  }

  cpuCalc(isFlip, firstTooth, secondTooth) {
    const startTime = Date.now();
    const workerURL = URL.createObjectURL(this.heatMapGenerationBlob);
    let worker = new Worker(workerURL);

    const invertedMatrixT1 = firstTooth.matrix.clone().invert();
    const invertedMatrixT2 = secondTooth.matrix.clone().invert();

    let vertices1 = this.applyObjectPositionFast(
      firstTooth,
      firstTooth.matrix.clone(),
    );
    let vertices2 = this.applyObjectPositionFast(
      secondTooth,
      secondTooth.matrix.clone(),
    );

    worker.onmessage = function (e) {
      const filteredColors = firstTooth.geometry.attributes?.color?.array
        ? this.filterColorsCPU(
            e.data,
            firstTooth.geometry.attributes.color.array,
          )
        : e.data;

      firstTooth.geometry.setAttribute(
        "color",
        new THREE.BufferAttribute(filteredColors, 3),
      );

      firstTooth.isOcclusalCalculated = true;
      this.currentQueueLength--;

      // console.log("delay time ", Date.now() - startTime);
      worker.terminate();
      worker = null;
    }.bind(this);
    worker.postMessage(
      {
        vertices1,
        vertices2,
        isLower: isFlip ? -1 : 1,
      },
      // [vertices1.buffer, vertices2.buffer],
    );
    this.applyObjectPositionFast(firstTooth, invertedMatrixT1);
    this.applyObjectPositionFast(secondTooth, invertedMatrixT2);
  }

  applyObjectPositionFastOld(object) {
    const startTime = Date.now();
    if (!object.geometry || !object.geometry.attributes.position) {
      console.warn("Geometry or position attribute not found.");
      return;
    }

    if (
      object.position.x === 0 &&
      object.position.y === 0 &&
      object.position.z === 0
    ) {
      return object.geometry.attributes.position.array;
    }
    const geometry = object.geometry.clone();

    object.updateMatrix();
    geometry.applyMatrix4(object.matrix);

    // geometry.attributes.position.needsUpdate = true;
    return geometry.attributes.position.array;
  }

  applyObjectPositionFast(object, matrix) {
    object.geometry.applyMatrix4(matrix);
    return object.geometry.attributes.position.array;
  }

  filterColorsCPU(array1, array2) {
    if (!array1) {
      return array2;
    }
    if (!array2) {
      return array1;
    }
    // console.log(array1, array2);

    const result = new Float32Array(array1.length);

    for (let i = 0; i < array1.length; i += 3) {
      // Read RGB values directly
      const r1 = array1[i],
        g1 = array1[i + 1],
        b1 = array1[i + 2];
      const r2 = array2[i],
        g2 = array2[i + 1],
        b2 = array2[i + 2];

      // Select color based on priority

      const selectedColor = this.compareColors(r1, g1, b1, r2, g2, b2);
      // Assign to result
      result[i] = selectedColor[0];
      result[i + 1] = selectedColor[1];
      result[i + 2] = selectedColor[2];
    }

    return result;
  }

  // Direct number comparison for best performance
  compareColors(r1, g1, b1, r2, g2, b2) {
    const p1 = this.getPriority(r1, g1, b1);
    const p2 = this.getPriority(r2, g2, b2);

    return p1 <= p2 ? [r1, g1, b1] : [r2, g2, b2];
  }

  // Inline priority check (Lower number = Higher priority)
  getPriority(r, g, b) {
    if (r >= 0.85 && g === 0 && b >= 0) return 1; // Red (Highest Priority)
    if (r === 1 && g > 0.5 && b === 0) return 2; // Orange
    if (r === 0 && g === 1 && b === 0) return 3; // Blue
    if (r === 1 && g === 1 && b === 1) return 4; // White (Lowest Priority)
    console.log("error", r, g, b);

    return 99; // Anything else (should never happen)
  }
}

export function generateHeatmapsByName(movedTeeth) {
  movedTeeth.forEach(toothName => {
    const tooth = teeth3DControlsObjectByName[toothName];

    const isLower = toothName.charAt(0) === "l";
    if (isLower) {
      heatMapManager.executeTaskImmediatelyAfterTime(
        teeth3DControlsObjectByJaw.upper,
        [tooth],
      );
    } else {
      heatMapManager.executeTaskImmediatelyAfterTime(
        [tooth],
        teeth3DControlsObjectByJaw.lower,
      );
    }
  });
}
